<div class="d-flex header-container" *ngIf="!isMobileView && !isLinkOff">
    <div class="col-flex ml-2">
        <label class="title mt-3">{{data?.outlet}}, {{data?.business}}</label>
        <label *ngIf="data?.is_welcome_banner_text" class="description">{{data.welcome_banner_text}}</label>
    </div>
    <div class="right-sticky-layout" *ngIf="data?.business_logo">
      <div class="logo-container">
        <img class="logo" [src]="data?.business_logo" alt="logo">
      </div>
    </div>
</div>

<div class="header-container" *ngIf="isMobileView && !isLinkOff">
    <div class="col-flex">
        <div *ngIf="data?.business_logo" class="logo-container row m-0 w-100">
            <img class="logo" [src]="data.business_logo" alt="logo">
        </div>
        <label class="title mt-3">{{data?.outlet}}, {{data?.business}}</label>
        <label *ngIf="data?.is_welcome_banner_text" class="description">{{data.welcome_banner_text}}</label>
    </div>
</div>

<div class="header-container" *ngIf="isLinkOff">
  <div class="col-flex m-0">
      <div *ngIf="data?.business_logo" class="logo-container row m-0 w-100">
        <img class="logo" [src]="data.business_logo" alt="logo">
      </div>
      <label class="link-off-title mt-3 m-auto">{{data?.outlet}}, {{data?.business}}</label>
  </div>
</div>
